"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = exports.Dashboard = void 0;
const Dashboard_yaml_component_1 = __importDefault(require("./Dashboard.yaml?component"));
exports.Dashboard = Dashboard_yaml_component_1.default;
const Notifications_yaml_component_1 = __importDefault(require("./Notifications.yaml?component"));
exports.Notifications = Notifications_yaml_component_1.default;
